
















import Vue from 'vue'
const menuList = [
  {
    name: '课程',
    path: '/main/keCheng',
    img: '/static/image/bar_kecheng.png',
    imgActive: '/static/image/bar_kecheng_a.png',
  },
  {
    name: '评价',
    path: '/main/keChengToday',
    img: '/static/image/bar_kejian.png',
    imgActive: '/static/image/bar_kejian_a.png',
  },
  {
    name: '我的',
    path: '/main/user',
    img: '/static/image/bar_user.png',
    imgActive: '/static/image/bar_user_a.png',
  },
]
export default Vue.extend({
    data() {
        return {
            menuList,
        }
    },
})
